import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'
import lookups from '@/assets/json/clientLookups.json'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}
const changePersonPhotoFlagAction = () => {
  const formStore = useFormStore()
  formStore.form.values.changePersonPhotoFlag == 1 &&
    doNotify(i18n.global.t('Errors'), i18n.global.t('changePersonPhotoFlagHint'))
}

const filterReplacementTypes = ({ options } = actionParams) => {
  const authStore = useAuthStore()

  if (!authStore.isUserTypingCenter && !authStore.isUserServiceCenter) {
    return options.filter((r) => r.id != 3)
  }
  return options.filter(
    (r) => r.id != lookups.replacementTypesEidaForResi.changePassportForResidency
  )
}

export default function (actionName, actionParams) {
  switch (actionName) {
    case 'filterReplacementTypes':
      return filterReplacementTypes(actionParams)
    case 'changePersonPhotoFlagAction':
      return changePersonPhotoFlagAction(actionParams)
    default:
      break
  }
}
